import { useState } from "react";
import { Link } from "react-router-dom";
import { useBrand } from "../../context/BrandContext";
import ThemeToggle from "../common/ThemeToggle";
import "./PublicCareers.css";

export function apiError(err, fallback) {
  const message = err?.response?.data?.message;
  if (Array.isArray(message)) return message.join("\n");
  if (typeof message === "string" && message.trim()) return message;
  return err?.message || fallback;
}

export function employmentTypeLabel(type) {
  if (type === "PART_TIME") return "دوام جزئي";
  if (type === "TEMPORARY") return "مؤقت";
  return "دوام كامل";
}

export function CareersShell({ children }) {
  const brand = useBrand();
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="careers-page">
      <header className="careers-header">
        <Link to="/careers" className="careers-brand">
          {!logoFailed ? (
            <img
              src={brand.logoPath}
              alt={brand.companyName}
              className="careers-logo"
              onError={() => setLogoFailed(true)}
            />
          ) : (
            <div className="careers-logo-fallback">{brand.shortName}</div>
          )}
          <div>
            <p className="careers-company">{brand.companyName}</p>
            <p className="careers-tagline">بوابة التوظيف</p>
          </div>
        </Link>
        <div className="careers-header-actions">
          <ThemeToggle variant="icon" />
          <Link to="/login" className="careers-login">
            دخول الموظفين
          </Link>
        </div>
      </header>
      <main className="careers-main">{children}</main>
    </div>
  );
}
